var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowDownRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.5 13c0 6.893-5.607 12.5-12.5 12.5C6.108 25.5.5 19.893.5 13S6.108.5 13 .5C19.893.5 25.5 6.107 25.5 13z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.276 11.197a.933.933 0 01-.274.661l-4.337 4.359a.939.939 0 01-1.329 0l-4.34-4.359a.936.936 0 111.329-1.322L13 14.226l3.675-3.69a.937.937 0 011.601.66z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconArrowDownRed;